// removed by extract-text-webpack-plugin
module.exports = {"slickslider":"ucB76esOc5IFqst_2IGj7","itemWrap":"_2tR6SBnFvuKCGcGRoXSbof","next":"PY-Rf57dvfRrGM6lTeKtP","prev":"_21YR4Q1zstUnEo2PFFFj8i","white":"_1Eto2zONQsM7_YfemCuzIx"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/third-party/SlickCarousel/style.css
// module id = 637
// module chunks = 38